var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlinePaymentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H13.2414C7.58522 4 3 8.92487 3 15M13.6207 7.66667H13.2414C9.47061 7.66667 6.41379 10.9499 6.41379 15M13.6207 10.9259H13.2414C11.1465 10.9259 9.44828 12.75 9.44828 15",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0182 13.127V21.5103H33V27.921H12.0547V13.127H26.0182Z",
    fill: "#82BD54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0129 17.207H26.1865V21.5161H32.1874L30.0129 17.207Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6378 21.7785L30.0129 17.207H26.1865V24.0939",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4613 29.4458C19.4613 30.5846 18.5464 31.501 17.4259 31.501C16.3055 31.501 15.3906 30.5846 15.3906 29.4458C15.3906 28.3071 16.3055 27.3906 17.4259 27.3906C18.5464 27.3906 19.4613 28.3071 19.4613 29.4458Z",
    fill: "white",
    stroke: "#383434"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3265 29.4458C30.3265 30.5846 29.4116 31.501 28.2912 31.501C27.1708 31.501 26.2559 30.5846 26.2559 29.4458C26.2559 28.3071 27.1708 27.3906 28.2912 27.3906C29.4116 27.3906 30.3265 28.3071 30.3265 29.4458Z",
    fill: "white",
    stroke: "#383434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinePaymentIcon);
export default __webpack_public_path__ + "static/media/onlinePaymentIcon.a41019652f40e28596f234ef984da8a9.svg";
export { ForwardRef as ReactComponent };